import { render } from "./P041.vue?vue&type=template&id=325a4c01&scoped=true"
import script from "./P041.vue?vue&type=script&lang=js"
export * from "./P041.vue?vue&type=script&lang=js"

import "./P041.vue?vue&type=style&index=0&id=325a4c01&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325a4c01"]])

export default __exports__